import React, { Component } from 'react';

class ActivityCount extends Component {
    render() {
        const { name, count } = this.props;
        return (
            <div className="col-6 col-md-6 col-lg-6 col-xl-3">
                <div className="panel-button-wrapper d-flex">
                    <div className={this.props.styleName}>{count}</div>
                    <span>{name}</span>
                </div>
            </div>
        )
    }
}

export default ActivityCount;
